export default __webpack_public_path__ + "static/media/LLinkedIn.caecadfa.svg";